import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { Parameter } from '../models/parameter.model';
import { map } from 'rxjs/operators';
import { CacheService } from './cache.service';
@Injectable({
   providedIn: "root"
})
export class ParameterService {

   className = 'ParameterService';

   constructor(private http: HttpClient, @Inject("environment") private environment: any, private cacheService: CacheService) { }

   getAllParameters(cache = true, cacheKey = "parameters"): Observable<Parameter[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<Parameter[]>(this.environment.base_URL + "/parameters").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   getParametersByName(name): Observable<Parameter[]> {
      return this.http.get<Parameter[]>(this.environment.base_URL + "/parameters").pipe(map<any[], any>(res =>
         _.find(res, item => { return item.txtComment === name }).txtValor
      ));
   }

   newParameter(parameter) {
      return this.http.post(this.environment.base_URL + "/parameters", parameter);
   }

   updateParameter(parameter, id) {
      return this.http.put(this.environment.base_URL + `/parameters/${id}`, parameter);
   }

   deleteParameter(id: Number) {
      return this.http.delete(this.environment.base_URL + `/parameters/${id}`);
   }
}
